import { useQuery } from '@tanstack/react-query';

import { useEventbus } from './useEventbus';

import IdpHandlerInstance from '@user/IdpHandler';

export const useUser = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['idp-user'],
    queryFn: async () => {
      const idp = await IdpHandlerInstance.waitIdpReady();
      const logged = await idp.isFanLoggedIn();
      const data = await idp.getFan();
      return {
        data: data?.success ? data?.value : null,
        logged: logged,
      };
    },
    placeholderData: {
      data: null,
      logged: false,
    },
  });

  useEventbus(() => {
    refetch();
  }, 'userLogged');

  return { ...data, isLoading };
};
